import React, { useEffect, useState } from "react";
import "./style.css";
import { useNavigate, NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LoginSection from "./components/LoginSection";
import ThreeSteps from "./components/ThreeSteps";
import PaymentOfferSection from "./components/PaymentOfferSection";
import FAQSection from "./components/HomeFaq";

const Home = () => {
  const navigate = useNavigate();
  const authStatus = useSelector((state) => state.auth);
  const isLoggedIn = authStatus.isLoggedIn;

  useEffect(() => {
    window.scrollTo(0, 0);
    if (isLoggedIn) {
      navigate("/dashboard");
    }

    const urlParams = new URLSearchParams(window.location.search);
    const referrerCode = urlParams.get("referrer");
    if (referrerCode) {
      sessionStorage.setItem("referrerCode", referrerCode);
    }
  }, [isLoggedIn, navigate]);

  return (
    <>
      <LoginSection />
      <ThreeSteps />
      <PaymentOfferSection />

      <section className="referral-section" id="referral">
        <div className="container py-5">
          <div className="row">
            <div className="col-md-4">
              <div className="refrell-item">
                <div className="img">
                  <img src="./images/ref1.jpg" alt="" />
                </div>
                <div className="refrell-content">
                  <h3 className="offers-title">Register and Earn Rewards</h3>
                  <p>
                    {" "}
                    Create your profile with us by signing up using your Google
                    account. After registering, you’ll gain access to a variety
                    of surveys and studies. Complete these surveys to earn
                    rewards.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="refrell-item">
                <div className="img">
                  <img src="./images/ref2.jpg" alt="" />
                </div>
                <div className="refrell-content">
                  <h3 className="offers-title">Refer With Your Network</h3>
                  <p>
                    {" "}
                    Refer friends, family, or colleagues to join our platform.
                    For every survey they complete, you’ll earn 10% of their
                    reward points.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="refrell-item">
                <div className="img">
                  <img src="./images/ref3.jpg" alt="" />
                </div>
                <div className="refrell-content">
                  <h3 className="offers-title">
                    Enjoy Unlimited Earning Potential
                  </h3>
                  <p>
                    {" "}
                    There’s no limit to how much you can earn. The more people
                    you refer, the more you can increase your earnings.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="steps-wrapper position-relative bg-2 pt-5" id="app">
        <div className="container text-center">
          <div className="row justify-content-center align-items-center mb-4">
            <div className="col-md-9">
              <div className="heading-section-left pb-2 mt-0">
                <h2>Get Started with Poll Sphere</h2>
                <p>
                  Join thousands of users who trust Poll Sphere for their survey
                  needs. Download our mobile app to participate in surveys
                  anytime, anywhere. Share your valuable opinions and earn
                  rewards while making a difference.
                </p>
              </div>

              <div className="app-links d-flex justify-content-center gap-3 pb-5">
                <div className="ios">
                  <img src="./images/app/01.jpg" alt="Download on App Store" />
                </div>

                <div className="android">
                  <NavLink className="d-inline-block" to="#">
                    <img
                      src="./images/app/02.jpg"
                      alt="Get it on Google Play"
                    />
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
          </div>
      </section>
      <FAQSection />
    </>
  );
};

export default Home;
